import { gql } from "@apollo/client";

export const CREATE_WORK_FLOW_CONFIGURATION = gql`
  mutation CreateWorkFlowConfiguration(
    $input: createWorkFlowConfigurationInput
  ) {
    createWorkFlowConfiguration(input: $input) {
      Id
      deptId
    }
  }
`;

export const GET_WORKFLOW_CONFIGURATION = gql`
  query GetWorkFlowConfiguration($deptId: Int, $roleId: Int) {
    getWorkFlowConfiguration(deptId: $deptId, roleId: $roleId) {
      Id
      deptId
      roleId
      accessType
      orgId
      createdOn
      screenId
      subAccess
      timeFrame
    }
  }
`;

export const GET_WORKFLOWCONFIGURATION_ONACESS = gql`
  query GetWorkFlowConfigurationonAcess($accessType: String, $screenId: Int) {
    getWorkFlowConfigurationonAcess(
      accessType: $accessType
      screenId: $screenId
    ) {
      Id
      deptId
      roleId
      accessType
      orgId
      createdOn
      subAccess
      screenId
      timeFrame
    }
  }
`;

export const UPDATE_WORKfLOW_CONFIGURATION = gql`
  mutation UpdateWorkFlowConfiguration(
    $input: updateWorkFlowConfigurationInput
  ) {
    updateWorkFlowConfiguration(input: $input)
  }
`;

export const UPDATE_MULTIPLE_WORKfLOW_CONFIGURATION = gql`
  mutation UpsertWorkFlowConfigurations(
    $inputs: [updateWorkFlowConfigurationInput]
  ) {
    upsertWorkFlowConfigurations(inputs: $inputs) {
      successCount
      createCount
      deletedCount
      total
    }
  }
`;


